import React from 'react';

import styles from './MainContainer.module.scss';

const MainContainer: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={`container ${styles.mainContainer}`}>{children}</div>;
};

export default MainContainer;
